export default __webpack_public_path__ + "static/media/heroplus-bg1-223f93d89fedb6c2ca474c27830bf6e0.png";